export const snakeToSentence = (str: string) => str
	.replace(/_/g, ' ')
	.replace(/^\w/, c => c.toUpperCase())